import React, { useEffect, useState } from 'react';
import { AAFESAuth } from '../components/origins/AAFESAuth';
import { NEXAuth } from '../components/origins/NEXAuth';
import { SSAuth } from '../components/origins/SSAuth';
import { WRENAuth } from '../components/origins/WRENAuth';
import { REFERRERS } from '../util/constants';
import { parseRequestBody } from '../util/utils';

export const Home = () => {
  const [requestBody, setRequestBody] = useState('');
  const [referrer, setReferrer] = useState('');

  useEffect(() => {
    const requestBodyValue = window.document.getElementById('requestBody')
      && window.document.getElementById('requestBody').value;
    const referrerValue = window.document.getElementById('referrer')
      && window.document.getElementById('referrer').value;

    setRequestBody(requestBodyValue);
    setReferrer(referrerValue);
  }, []);

  return (
    <>
      {REFERRERS.AAFES.some((domain) => referrer.includes(domain))
        && <AAFESAuth requestBody={parseRequestBody(requestBody)} />}
      {referrer.includes(REFERRERS.NEX)
        && <NEXAuth requestBody={parseRequestBody(requestBody)} />}
      {REFERRERS.SS.some((domain) => referrer.includes(domain))
        && <SSAuth requestBody={parseRequestBody(requestBody)} />}
      {REFERRERS.WREN.some((domain) => referrer.includes(domain))
        && <WRENAuth requestBody={parseRequestBody(requestBody)} />}
    </>
  );
};

Home.propTypes = {};

Home.displayName = 'StorefrontAuth';

Home.defaultProps = {};
